// @ts-check
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';//??
// import '../node_modules/bootstrap-icons/font/bootstrap-icons.min.css';
//CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
//import '../node_modules/intl-tel-input/build/css/intlTelInput.min.css';
import 'intl-tel-input/build/css/intlTelInput.min.css';
import './style.css';
import './sp.css';
import './pb.css';
import './social.css';

//JS
//import 'bootstrap';
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as bootstrap from 'bootstrap';
//
import 'video.js/dist/alt/video.core.min.js';
import 'videojs-youtube/dist/Youtube.min.js';

//
import * as Shareon from "shareon";
import "shareon/css";

import intlTelInput from 'intl-tel-input';
import { config} from './config/config.js';
import { Utils } from './util/utils.js';
import { PbUtils } from './util/pb-utils.js';
import { FetchUtils } from './util/fetch-utils.js';
import {ValidationUtils} from './util/validation-utils.js';
import { TemplateUtils } from './util/template-utils.js';
import { PageBuilder } from './component/page-builder.js';
import { Home } from './component/home.js';
import { Login } from './component/login.js';
import { Register } from './component/register.js';
import { Dashboard } from './component/dashboard.js';
import { Media } from './component/media.js';
import { th } from 'intl-tel-input/i18n';

class Main{
constructor(){
this.shareon = Shareon;
this.bootstrap = bootstrap;
this.intlTelInput = intlTelInput;
this.config = config;
this.utils = new Utils(this);//??
this.pbu =  new PbUtils(this);
this.fu = new FetchUtils(this);
this.vu = new ValidationUtils(this);
this.tu = new TemplateUtils(this);
this.pb = new PageBuilder(this,null);
this.media = new Media(this);
this.modal = null;
this.offCanvas = null;
this.state = null;
//temp
this.logEntries = [];
this.siteDomains = ['localhost:5173','localhost:4173','senplat.com','sp.senplat.com','sp2.senplat.com'];
this.sitename = 'senplat';
this.siteDomain = 'senplat.com';
this.r2Domain = 'https://r2.senplat.com';
this.adminHome = '/app/dashboard/page/detail/0';
this.isSiteDomain = false;
this.isSite = false;
this.isSiteHome = false;
this.isInit = false;
this.isMobile = false;
this.isRoot = false;
this.init();
//
}//
init(){
  //pop
window.addEventListener('popstate', (e) => {
    e.preventDefault();
   if(e.state){
    this.log(e.state,'Main.init(): popstate - evt.state');
    e.state.isPop = true;
    e.state.isInit = false;
    this.navigate(e.state);
   }
});
//
window.addEventListener('error',(/**@type {ErrorEvent}*/e)=>{
if(e.error.message!='die'){
this.utils.notify(this.config.ERROR_MESSAGE.toUpperCase(),{});
}
this.log('uncaught error','Main.init()',2,'EXCEPTION',e.error,true);
});
//
window.addEventListener('unhandledrejection',(e)=>{
if(e.reason.message!='die'){
this.utils.notify(this.config.ERROR_MESSAGE.toUpperCase(),{});
}
this.log('unhandledrejection','Main.init()',2,'EXCEPTION',e.reason,true);
});


let pathname = window.location.pathname;
window.history.replaceState(null,'',pathname);
this.host = window.location.host.toLowerCase();
this.origin = window.location.origin;


if(this.host=='localhost:8081'){
  this.isStage = true;
  //this.host = this.siteDomain;
  this.host = 'godlysensation.senplat.com';
  this.origin = 'https://godlysensation.senplat.com';
}
if(this.isDev()){
//this.host = 'sp.senplat.com';
//this.host = 'sp2.senplat.com';
//this.host='godlysensation.com';
this.host = 'godlysensation.senplat.com';
this.origin = 'https://godlysensation.senplat.com';
//this.host = 'hhaw.senplat.com';
//this.host = 'vazzini.senplat.com';
//this.host = this.siteDomain;
}

if(pathname.startsWith('/testuser')){
let path = pathname.split('/');
let username = path[2];
this.host = `${username}.${this.siteDomain}`;
pathname = '/';
if(path[3]=='login')
pathname = '/app/login';
}

this.log(this.host,'Main.init(): host');
this.isSite = (this.host == this.siteDomain) || (this.host == 'sp2.senplat.com');
if((this.host.endsWith(this.siteDomain)) && !this.isSite ){
 this.username = this.host.split('.')[0];
}else{
    this.username = this.host;
}
//
this.isRoot = ['godlysensation','sp2'].includes(this.username);
this.isMobile = window.matchMedia('(max-width: 767.98px)').matches;
//remove last string i.e '/'
if(pathname.endsWith('/')){
pathname = pathname.slice(0, -1);
}

if(pathname.startsWith('/app')){
//###LIVE TEST
//pathname = '/app/dashboard/page/detail/0';
this.handleAdmin(pathname,true);
}else{
  //###LIVE TEST
this.handleView(pathname,true);
}

//
  //temp
setInterval(()=>{
if(this.logEntries.length>0){
  this.fu.fetch({link:this.fu.getApi('/app/log/save'),body:JSON.stringify(this.logEntries)});
  this.logEntries = [];
}
}, 30*60*1000);
}//func

die(){
throw new Error('die');
}//func

/**
 * 
 * @param {any} component 
 */
finalize(component){
  if(!component){return;}
  component.controller?.abort();

  //variable are contained here
  if(component.cleanups){
    for(let cleanup of component.cleanups){
      cleanup();
    }
  }
    //
    if(component.evtHandlers){
      component.evtHandlers.forEach(func=>func=null);
      component.evtHandlers = [];
    }

 for (let [key, value] of Object.entries(component)) {
      this.log(key,'Main.finalize(): object key');
         if(value instanceof Element){
          if(value.parentNode){
            value.parentNode.removeChild(value);
          }
         }
         //key = null;
         value = null;
         
        }
  this.log('finalized','Main.finalize():');
}//

/**
 * @param {string} pathname
 * @param {boolean} isInit  
 */
handleView(pathname,isInit){
this.isView = true;
this.navigate(this.getHomeState(pathname,isInit));
}//func

/**
 * 
 * @param {string} pathname 
 * @param {boolean} isInit
 */
handleAdmin(pathname,isInit){
this.isView = false;
let paths = pathname.split('/');
let length = paths.length;
let state;
 if(length==3){
  this.isView = false;
  //eg: senplat.com/app/login 
    if(paths[2]=='register'){
      //domain here must be site
      state = {component:'register',url:pathname,isInit:isInit}; 
    }else{
      //this is for a tenant or its user to login from their site eg: app/login 
      //maybe initialize the login page
      state = {component:'login',url:pathname,isInit:isInit}; 
    
    }

  }else if(length==6){
    //standard lenght
    state = this.getState(pathname,isInit);
    //note: admin link starts with app so lenght is 6 as opposed to normal view which is 5
  }else{
    //not found or home or login
    state = {component:'login',url:pathname,isInit:isInit}; 
  }
  this.navigate(state);
}//

/**
 * 
 * @param {Event|string} input - Event or pathname
 * @param {boolean} isInit
 * @returns 
 */
getState(input,isInit=false){
let pathname;
if(input instanceof Event){
let el = input.target;
let url = new URL(el.href);
pathname = url.pathname;
}else{
    pathname = input;
}
let paths = pathname.split('/');//check url segments
//note: path[0] returns an empty string
//note: path[1] = app
let state =
{
component : paths[2],
postType:paths[3],
type : paths[4],
id : Number(paths[5]),
url: pathname,
isInit:isInit,
isAdmin:true,
nextState:null
};
//temp
if(state.component=='media'){
  state.mediaType = state.postType;
  delete state.postType;
}
this.log(state,'Main.getState(): state');
return state;
}//func

/**
 * 
 * @param {string} pathname 
 * @param {boolean} isInit 
 * @returns 
 */
getHomeState(pathname,isInit=false){
let component ='post';
let postType = 'page';
let archiveType = 's';
let title,id;
if(pathname=='/' || pathname==''){
title = 'home';
id = 0;
}else{
let paths = pathname.split('/');
let length = paths.length;
if(length==6){//i.e localhost/post/page/s/about/4
component = paths[1];
postType = paths[2];
archiveType = paths[3];
title = paths[4];
id = paths[5];
}else if(length==3){
  //old wordpress site
  component = 'post';
  postType = 'post';
  archiveType = 's';
  title = paths[2];
  id = -404;
  pathname = this.getHomeLink(component,postType,archiveType,title,id);
}else{
  //simulated not found page
  component = 'post';
  postType = 'page';
  archiveType = 's';
  title = 'Not Found';
  id = -404;
  pathname = this.getHomeLink(component,postType,archiveType,title,id);
}
}
let homeState = {
username:this.username,
component:component,
type:'detail',
postType:postType,
archiveType:archiveType,
isArchive:archiveType!='s',
title:title,
id:Number(id),
isHome:(title=='home') && id==0,
isView:true,
isInit:isInit,
nextState:null,
url:pathname,
};
this.log(homeState,'Main.homeState(): homeState');
return homeState;
}//func
/**
 * 
 * @param {*} isInit 
 * @returns 
 */
getLoginState(isInit,nextState=null){
let state = {component:'login',url:'/app/login',isInit:isInit,nextState:nextState};
this.log(state,'Main.getLoginState(): Login state');
return state;
}//func

/**
 * @param {string} component
 * @param {string} postType
 * @param {string} archiveType
 * @param {string} title 
 * @param {number|string} id 
 * @returns 
 */
getHomeLink(component,postType,archiveType,title,id){
let url;
let isHome = title=='home';
if(isHome){
url = '/';
}else{
  url = `/${component}/${postType}/${archiveType}/${title}/${Number(id)}`;
}  
return url.toLowerCase();
}//func

/**
 * 
 * @param {string} component 
 * @param {string} postType 
 * @param {string} type 
 * @param {number|string} id 
 * @returns 
 */
getLink(component,postType='page',type='detail',id=0){
return  `/app/${component}/${postType}/${type}/${Number(id)}`;
}//func

/**
 * 
 * @param {HTMLAnchorElement} link 
 */
makeLink(link){
this.pbu.listen(link,'click',(e)=>{
e.preventDefault();
let pathname = link.pathname;
if(pathname.startsWith('/app')){
this.handleAdmin(pathname,false);
}else{
this.handleView(pathname,false);
}
})
}


/**
 * 
 * @param {string} type 
 * @param {boolean} isNav 
 * @param {boolean} isSlug 
 * @param {boolean} asArray 
 * @returns 
 */
addRouteClass(type="detail",isNav=false,isSlug=false,asArray=false){
  let rc = ['sp-route-link'];
  if(type=='detail'){
    rc.push('sp-detail');
  }else if(type=='admin'){
    rc.push('sp-admin');
  }
  if(isNav){
    rc.push('sp-nav-link', 'nav-link');
  }
  if(isSlug){
    rc.push('sp-slug-link');
  }
  return (asArray)?rc: rc.join(' ');
}
/**
 * 
 * @param {Event|any} state 
 */
async navigate(state){
this.state = state;
this.spin();
// if(state.prevComponentClasz){
//   this.finalize(state.prevComponentClasz);
//   state.prevComponentClasz = null;
// }
switch(state.component){
case 'login':
new Login(this,state);
break;
case 'register':
new Register(this,state);
break;
case 'dashboard':
this.dashboard = new Dashboard(this,state);
break;
case 'option':
case 'menu':
case 'media':
case 'user':
case 'category':
case 'post':
case 'page':////note: no actual page component, but generic views like error use this
if(state.isView){
//this.finalize(this.home);
this.home = this.home || new Home(this,state);
this.home.state = state;
await this.home.getClientHome();
}else{
if(!this.dashboard){
  let dashboardState = this.getState(this.getLink('dashboard'),state.isInit);
  this.dashboard = new Dashboard(this,dashboardState);
  }
//Note: dashboard template may had been taken out eg when re-authenticating after session timeout
this.dashboard.mount(null);
this.dashboard.mount(state);
}
break; 
}//switch
//finally
if(state.isPop){//??
//do nothing
}else{
this.pushState(state);
}
//maybe animate here
window.scrollTo(0, 0);
this.spin(false);
}//func

/**
 * 
 * @param {boolean} show 
 */
spin(show=true){
this.spinnerSection = this.spinnerSection || document.querySelector('section#spinner');
if(show){
this.spinnerSection.classList.remove('hidden');
}else{
this.spinnerSection.classList.add('hidden');
}

}


/**
 * 
 * @param {any} message 
 * @param {string} action 
 * @param {number} level 
 * @param {string} logType 
 * @param {Error} error 
 * @param {boolean} save -wether to save to backendv
 */
async log(message,action='',level=0,logType='EXCEPTION',error=null,save=false){
//if(!message.startsWith('un')){return;}
//(String action,Object message,int level,String logType, auth,Exception e) 
if(import.meta.env.MODE=='development'){
console.log("========start============")
console.log("Action: "+action);
console.log(message);
if(error){
console.log(error);
}
console.log("==========end===============");
///

///
}else{
  //in prod
if(save){
let log= {
action:action,
message:message,
level:level,
source:"frontend",
logType:logType,
state:null,
exceptionType:error.name||'',
exceptionRootCause:'',
exceptionMessage:error.message||'',
exceptionStackTrace:error.stack||''
};
if(this.state){
let state = this.utils.clone(this.state);
if(state.stateObject){
  delete state.stateObject;
}
for (const key in state) {
  if (this.utils.isNull(state[key])) {
    delete state[key];
  }
}
log.state = JSON.stringify(state);
}//for


if(this.isView){
if(this.home?.postViewDto){
log.username = this.home.postViewDto.option.username;
log.tenantId = this.home.postViewDto.option.tenantId;
log.tenantUuid = this.home.postViewDto.option.tenantUuid;
}

}else{
this.setTenant(log);
}
this.logEntries.push(log);
}
///
}
}//func

/**
 * 
 * @param {any} responseJson 
 * @param {any} state
 */
handleError(responseJson,state){
this.log(responseJson,'Main.handleError(): Response with error');
let errorCode = Math.abs(Number(responseJson.id));
let dismissNotice = state.dismissNotice || false;//wether to auto close the notification
let customNotice;
if(state.isModal){
customNotice = this.modal.notice;  
dismissNotice = false;
}
if(state.isOffCanvas){
customNotice = this.offCanvas.notice;  
dismissNotice = false;
}

switch (errorCode){
                case 401://Unauthorized
                case 403:
                case 807://forbidden
                    break;
                case 404://Guest
                     //temp: message here is empty, will be centralized on backend
                    this.navigate({component:'post',url:'page/404',isView:true,hasError:true,message:"",responseJson:responseJson,errorType:"404"});
                    case 804://Not Deleted
                    break;
                case 805://Session timedout
                case 405://not authenticated
                    this.navigate(this.getLoginState(false,state));
                    break;
                case 806://Limit Exceeded
                    break;
                    case 811://Record exists
                    break;
            }//
            if(errorCode!=404){
              this.utils.notify(responseJson.message,{customMessageDiv:customNotice,dismiss:dismissNotice});             
            }
            
            this.die();
}//func

/**
 * 
 * @param {any} option 
 */
async setTheme(option){
if(option.activeTheme=='Default'){
  option.activeTheme=='Blue';
}
let theme = this.config.THEMES[option.activeTheme.toLowerCase()];
for (let property in theme) {
    document.documentElement.style.setProperty(property, theme[property]);
  }
  if(option.logoUrl){
    let icon = document.querySelector("link[rel='icon']");
    //icon.href = this.mh.getImageUrl(option.logoUrl,'public')  + "?v=" + Date.now();
    icon.href = this.media.getMediaUrl(option.logoUrl)+ "?v=" + Date.now();
  }
  
}//func
/**
 * 
 * @param {string} name 
 * @param {any} value 
 */
async setCache(name,value){
let jsonString = JSON.stringify(value);
let base64String = btoa(jsonString);
localStorage.setItem(name,base64String);
this.log(base64String,'User data saved');
}//func

/**
 * 
 * @param {string} name 
 * @returns 
 */
getCache(name){
    try{
    let base64String = localStorage.getItem(name);
    let jsonString = atob(base64String);
    let data = JSON.parse(jsonString);
    this.log(data,'User data retrieved from storage');
    return data;
    }catch(error){
      return '';
    }
    
}//

/**
 * 
 * @param {any} iResponse 
 */
setTenant(iResponse){
let user = this.getCache('user');
iResponse.username  = user.username;
iResponse.tenantId = user.tenantId;
iResponse.tenantUuid = user.tenantUuid;
}//func
/**
 * 
 * @param {any} state 
 */
pushState(state){
if(!state.url.startsWith('/')){
state.url = '/'+state.url;
}
if(state.id==-404){
  state.url = '/page/404';
}
window.history.pushState(state,'',state.url);
}//func
/**
 * 
 * @param {any} o 
 * @param {any} state 
 * @param {number} r
 */
replaceState(o,state,r){
if(!state.url.startsWith('/')){
state.url = '/'+state.url;
}
if(state.id==-1 && state.type=='new'){
o.id = state.id = r;
state.type = 'edit';
state.url = `/app/${state.component}/${state.postType}/edit/${r}`;
}
if(!state.isPartial){
window.history.replaceState(state,'',state.url);
}
return state;
}//func

/**
 * 
 * @param {HTMLInputElement} input 
 * @param {boolean} isView 
 * @param {any[]} items 
 * @param {string} type - currently post, tag
 * @returns 
 */
async autoComplete(input,isView,items,type='post'){
let $this = this;
let url;  
let form = input.closest('form.auto-complete');
let searchDisplay = form.querySelector('ul.search-post-display');
searchDisplay.innerHTML = '';
let searchTerm = input.value;
if(!searchTerm || searchTerm.length<2){
return;
}
if(!this.vu.sanitize([input])){
    return;
}

        if(items && items.length>0){
          let li;
        for(let i of items){
            if(type=='post'){
                url = this.getHomeLink('post',i.postType,'s',i.title,i.id);
                li = this.pbu.createElement('li',['list-group-item'],`${i.title} (${i.postType})`,[{n:'data-url',v:url}]);
            }else{
                li = this.pbu.createElement('li',['list-group-item'],`${i}`);
            }
        
        searchDisplay.appendChild(li);
      }
      //event
      document.addEventListener('click',handleOutsideClick);
      let lis = searchDisplay?.querySelectorAll('li');
      for(let li of lis){
          this.pbu.listen(li,'click',()=>{
            if(type=='post'){
                url = li.getAttribute('data-url');
            if(isView){
                this.handleView(url,false);
            }else{
                input.value= this.config.HOSTNAME + url;
                input.setAttribute('isInternal','true');
            }
            }else{
                input.value = li.textContent;
            }
            searchDisplay.innerHTML = '';
        });
      }
      //
      // this.pbu.listen(input,'blur',(e)=>{
      //   if(e.rangeParent.parentElement.nodeName=='LI'){
      //       return;
      //   }
      //   searchDisplay.innerHTML = '';
      // });
          
          
        }
/**
 * 
 * @param {PointerEvent} event 
 */
function handleOutsideClick(event){
let isClickInside = input.contains(event.target) || searchDisplay.contains(event.target);
$this.log(isClickInside,'Main.autoComplete.handleOutsideClick: autcomple menu click');
  if (!isClickInside) {
    searchDisplay.innerHTML = '';
    if(isView){
      //important: view is search, form has to be emptied, but others, value may be saved
       input.value = '';
    }
   
    document.removeEventListener('click',handleOutsideClick);
  }
}//inner
}//func

isDev(){
return import.meta.env.MODE=='development';
}//func

/**
 * 
 * @param {HTMLElement} component 
 */
addRouteEvents(component){
let routeLinks = [...component.querySelectorAll('.sp-route-link[href]')];
let formatLinks = component.querySelectorAll('.formatable a[href]');
for(let fl of formatLinks){
  this.pbu.addClass(fl,['sp-route-link','sp-detail']);
  routeLinks.push(fl);
}
for(let link of routeLinks){
  this.pbu.listen(link,'click',(e)=>{
       e.preventDefault();
    let isInit = link.classList.contains('sp-slug-link');
    if(link.classList.contains('sp-admin')){
      this.handleAdmin(link.pathname,isInit);
    }else if(link.classList.contains('sp-detail')){
    this.handleView(link.pathname,isInit);
    }
    
   
  });
}
}//func

}//class
var app = new Main();

